import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-documents-dialog.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-documents-dialog.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { ApplicationCreateService } from "../../application-create.service";
import { UserInformationService } from "../../../../shared/services/user/user-information.service";
import { SaLongDatePipe } from "../../../../shared/pipes/sa-long-date/sa-long-date.pipe";
import { AddDocumentDialogConstants } from "./add-document-dialog.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { AppConfig } from "../../../../app.config";
import { ApiAttachmentConstants } from "../../../../shared/constants/api-constants/api-attachment.constants";
import { FileUploadService } from "../../../../shared/services/file-upload/file-upload.service";
import { FileUtils } from "src/app/shared/utils/file-utils";
let AddDocumentsDialogComponent = class AddDocumentsDialogComponent {
    activeModal;
    requestStatusService;
    saLongDatePipe;
    userInformationService;
    applicationCreateService;
    fileUploadService;
    appControllerService;
    addDocumentForm;
    documentTypes = [];
    dialogTitle;
    configUploadSettings;
    currentApplication;
    selectedDocumentType;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    documentTypeLabel = AddDocumentDialogConstants.DOCUMENT_TYPE_LABEL;
    descriptionLabel = AddDocumentDialogConstants.DESCRIPTION_LABEL;
    fileLabel = AddDocumentDialogConstants.FILE_LABEL;
    selectFileLabel = AddDocumentDialogConstants.SELECT_FILE_LABEL;
    cancelBtnPlaceholder = AddDocumentDialogConstants.CANCEL_BTN_PLACEHOLDER;
    documentTypeFormControlName = AddDocumentDialogConstants.DOCUMENT_TYPE_FORM_CONTROL;
    descriptionFormControlName = AddDocumentDialogConstants.DESCRIPTION_FORM_CONTROL;
    fileNameFormControlName = AddDocumentDialogConstants.FILE_NAME_FORM_CONTROL;
    saveBtnPlaceholder = AddDocumentDialogConstants.SAVE_BTN_LABEL;
    uploadedFiles = [];
    documentTypeErrMsg = AddDocumentDialogConstants.DOCUMENT_TYPE_ERR_MSG;
    descriptionErrMsg = AddDocumentDialogConstants.DESCRIPTION_ERR_MSG;
    noFileUploadedErrMsg = AddDocumentDialogConstants.NO_FILE_UPLOADED_ERR_MSG;
    uploadedFileTooBigErrMsg = AddDocumentDialogConstants.UPLOADED_FILE_TOO_BIG_ERR_MSG;
    filetypeNotAllowedErrMsg = AddDocumentDialogConstants.UPLOADED_FILE_TYPE_NOT_ALLOWED_ERR_MSG;
    fileDetails;
    maxFileSize;
    allowedFileTypes = [];
    filteredAllowedFileTypes = [];
    documentUploadedBy;
    uploadDocumentObservableSubscription;
    constructor(activeModal, requestStatusService, saLongDatePipe, userInformationService, applicationCreateService, fileUploadService, appControllerService) {
        this.activeModal = activeModal;
        this.requestStatusService = requestStatusService;
        this.saLongDatePipe = saLongDatePipe;
        this.userInformationService = userInformationService;
        this.applicationCreateService = applicationCreateService;
        this.fileUploadService = fileUploadService;
        this.appControllerService = appControllerService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.initForm();
        this.maxFileSize = this.configUploadSettings.maximumSize;
        this.allowedFileTypes = this.configUploadSettings.agsSupportedAttachmentFileTypes.split(",");
        this.filteredAllowedFileTypes = FileUtils.mapAllowedFilesToMimeTypes(this.allowedFileTypes);
        this.userInformationService.$authenticatedUser.subscribe((userInfo) => {
            this.documentUploadedBy = `${userInfo.lastName} ${userInfo.firstName}`;
        });
        this.addDocumentForm.get(this.documentTypeFormControlName).setValue(this.selectedDocumentType);
    }
    onFileSelected(event) {
        this.requestStatusService.clearBusyRequestCounter();
        this.requestStatusService.showBusySpinner("upload");
        try {
            this.fileDetails = null;
            let file;
            if (event.target) {
                file = event.target.files[0];
            }
            else {
                file = event.item(0);
            }
            if (file) {
                const fileName = file.name;
                const uploadedFileSize = file.size;
                const fileExtension = fileName.split(".").pop();
                if (uploadedFileSize > this.maxFileSize) {
                    this.appControllerService.showMessage(this.uploadedFileTooBigErrMsg, AlertType.Warning);
                    return;
                }
                let fileTypeAllowed = false;
                for (const allowedFileType of this.allowedFileTypes) {
                    if (allowedFileType.trim().toUpperCase() === fileExtension.trim().toUpperCase()) {
                        fileTypeAllowed = true;
                        break;
                    }
                }
                if (fileTypeAllowed) {
                    this.fileDetails = file;
                    this.uploadedFiles[0] = file.name;
                }
                else {
                    this.appControllerService.showMessage(this.filetypeNotAllowedErrMsg, AlertType.Warning);
                }
            }
        }
        catch (e) {
            this.appControllerService.showMessage(AddDocumentDialogConstants.UPLOAD_ERROR_MSG, AlertType.Warning);
            this.requestStatusService.removeBusySpinner("upload");
        }
        this.requestStatusService.removeBusySpinner("upload");
    }
    onCancelBtnClicked() {
        this.activeModal.close();
    }
    onSaveBtnClicked() {
        this.requestStatusService.clearBusyRequestCounter();
        this.requestStatusService.showBusySpinner("upload");
        if (this.addDocumentForm.valid && this.addDocumentForm.touched && this.uploadedFiles.length > 0) {
            try {
                this.requestStatusService.clearBusyRequestCounter();
                this.requestStatusService.showBusySpinner("save");
                this.uploadAttachment();
            }
            catch (e) {
                this.appControllerService.showMessage(AddDocumentDialogConstants.UPLOAD_ERROR_MSG, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("save");
            }
        }
        else {
            Object.keys(this.addDocumentForm.controls).forEach(key => {
                if (this.addDocumentForm.get(key).invalid) {
                    this.addDocumentForm.get(key).markAsTouched();
                }
            });
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    deleteAttachment(i, $event) {
        this.uploadedFiles.splice(i, 1);
        if (this.uploadedFiles.length === 0) {
            this.addDocumentForm.get(this.fileNameFormControlName).reset();
        }
        $event.stopPropagation();
    }
    initForm() {
        this.addDocumentForm = new FormGroup({
            documentType: new FormControl(null, Validators.required),
            description: new FormControl(null, Validators.required),
            fileName: new FormControl(null)
        });
    }
    uploadAttachment() {
        this.requestStatusService.clearBusyRequestCounter();
        this.requestStatusService.showBusySpinner("upload");
        const formData = new FormData();
        formData.append("appId", this.currentApplication.appId.toString());
        formData.append("jobId", this.currentApplication.jobId.toString());
        formData.append("moduleId", this.appControllerService.selectedModuleID);
        formData.append("fileName", this.fileDetails.name);
        formData.append("description", this.addDocumentForm.get(this.descriptionFormControlName).value);
        formData.append("attachmentType", this.addDocumentForm.get(this.documentTypeFormControlName).value);
        formData.append("componentType", "Upload AFLA portal required documents");
        formData.append("aflaPortalObjectId", "0");
        formData.append("uploadedBy", this.documentUploadedBy);
        formData.append("file", this.fileDetails);
        formData.append("source", "On submission");
        const url = `${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.FUNCTION_UPLOAD_ATTACHMENT_FROM_PORTAL}`;
        this.fileUploadService.uploadFile(url, formData, "portal", "On submission", true, (result) => {
            if (result !== null) {
                this.appControllerService.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
                const newDocument = {
                    id: result.id,
                    type: this.addDocumentForm.get(this.documentTypeFormControlName).value,
                    name: this.addDocumentForm.get(this.descriptionFormControlName).value,
                    fileName: this.fileDetails.name,
                    dateUploaded: this.saLongDatePipe.transform(new Date().getTime().toString())
                };
                this.activeModal.close(newDocument);
            }
            this.requestStatusService.removeBusySpinner("save");
            this.requestStatusService.removeBusySpinner("upload");
        });
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: RequestStatusService },
        { type: SaLongDatePipe },
        { type: UserInformationService },
        { type: ApplicationCreateService },
        { type: FileUploadService },
        { type: AppControllerService }
    ];
    static propDecorators = {
        documentTypes: [{ type: Input }],
        dialogTitle: [{ type: Input }],
        configUploadSettings: [{ type: Input }],
        currentApplication: [{ type: Input }],
        selectedDocumentType: [{ type: Input }]
    };
};
AddDocumentsDialogComponent = __decorate([
    Component({
        selector: "app-add-documents-dialog",
        template: __NG_CLI_RESOURCE__0,
        host: { "add-documents-dialog": "create-application" },
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], AddDocumentsDialogComponent);
export { AddDocumentsDialogComponent };
